import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { StyledAccordionItem } from './AccordionItem.styles';

/**
 * A simple container used to wrap an `Accordion.Header` and `Accordion.Panel` set.
 *
 * @since 8.43.0
 */

export var AccordionItem = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledAccordionItem, _extends({
    ref: forwardedRef
  }, props));
});
AccordionItem.displayName = 'Accordion.Item';
AccordionItem.propTypes = {
  /**
   * The styled-components
   * [polymorphic "as"](https://styled-components.com/docs/api#as-polymorphic-prop) prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any,
  children: PropTypes.node.isRequired
};